import { z } from 'zod';

export const ReadConversationHistoryToolName = 'readConversationHistory';
export const readConversationHistoryArgsSchema = z.object({
  query: z
    .string()
    .max(300)
    .optional()
    .describe(
      'Keywords or exact identifier to search in this thread. Omit when opening messageId.',
    ),
  messageId: z
    .string()
    .uuid()
    .optional()
    .describe(
      'Open one original message by ID from search results or summary bookmarks.',
    ),
  offset: z
    .number()
    .int()
    .min(0)
    .max(10_000_000)
    .default(0)
    .describe(
      'Character offset for opening a message; result offset for search.',
    ),
});
